<template>
  <v-btn color="primary">Reset</v-btn>
</template>

<script>
export default {
  name: 'TableNoData'
}
</script>

<style scoped>

</style>
